import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    paddingTop: 36,
    paddingHorizontal: 16,
    gap: 24,
    flexGrow: 1,
    backgroundColor: `#FFF`,
  },
  inputContainer1: {
    flexDirection: 'row',
    width: '100%',
  },
  year: {
    flex: 0.9,
    marginRight: 8,
  },
  make: {
    flex: 1,
  },
  loan: {
    flexDirection: 'row',
    width: '100%',
  },
  firstButton: {
    marginRight: 8, // Gap between the buttons
  },
  loanText: {
    fontSize: 14,
    lineHeight: 32,
    fontWeight: 'bold',
  },
  loanButtons: { flexDirection: 'row', width: '100%', marginTop: -24 },

  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between', // Space between buttons
    gap: 8,
    width: '100%',
    paddingVertical: 12,
  },
  buttonWrapper1: {
    flex: 1, // Allow it to grow
    maxWidth: '33%', // Restrict to 33% width
  },
  buttonWrapper2: {
    flex: 1, // Allow it to grow
    maxWidth: '67%', // Restrict to 67% width
  },
});
